import { NgFor, NgIf } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { FuseCardComponent } from '@fuse/components/card';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import { SwiperPackagesComponent } from '../swiper-packages/swiper-packages.component';
import { MatIconModule } from '@angular/material/icon';  
@Component({
  standalone: true,
  selector: 'app-downgrade-package',
  templateUrl: './downgrade-package.component.html',
  styleUrls: ['./downgrade-package.component.scss'],
  imports: [MatDialogModule, FuseCardComponent, MatProgressSpinnerModule, MatButtonModule, NgIf, NgFor, SwiperPackagesComponent, MatIconModule]
})
export class DowngradePackageComponent {
  public packageDetails: any;
  public availablePackages: [];
  public loading: boolean = true;
  public packagesFound: boolean;
  public leadEntityID: number;
  constructor(private _sharedServices: SharedServiceService, private _sharedMethods: SharedMethodsModule, public dialogRef: MatDialogRef<DowngradePackageComponent>) {

  }

  async ngOnInit() {
    
    this.loading = true;
    this.packageDetails = this._sharedServices.activeCustomerServices;
    await this.getAvailablePackages()
  }


  ngOnDestroy(){
    this.closeDialog();
  }
  
  public async closeDialog() {
    await this.removeAllActiveLeads(this.packageDetails?.EntityAccountOfferableEntityID).then(() => {
      this.dialogRef.close();
    });
  }


  private async getAvailablePackages() {
    await this.removeAllActiveLeads(this.packageDetails?.EntityAccountOfferableEntityID).then((res) => {
      this._sharedMethods.generateLead(this.packageDetails?.EntityAccountOfferableEntityID, 'ServiceDowngrade').then((leadRes) => {
        this.leadEntityID = leadRes?.result?.LeadEntityID;
        if(leadRes.success) {
          this._sharedMethods.getAvailablePackages(leadRes?.result?.LeadEntityID).then((res) => {
            if(res.result.length) {
              this.availablePackages = res?.result;
              this.loading = false;
            } else {
                this._sharedMethods.cancelLeadById(leadRes?.result?.LeadEntityID).then((canelRes) => {
                this.loading = false;
              })
            }
          });
        }
      });
    })
  }

  private async removeAllActiveLeads(entityAccountOfferableEntityID: number): Promise<any> {
    return new Promise(resolve => {
      this._sharedMethods.getCustomerLeads().then((res) => {
        res.result?.forEach(element => {
          if(element?.LeadActionTypeCode == "ServiceDowngrade"){
            if (entityAccountOfferableEntityID === element?.UpdatingEntityAccountOfferableID) {
              this._sharedMethods.cancelLeadById(element.LeadEntityID).then((res) => {
                location.reload();
              });
            }
          }
        });
        resolve(null);
      });
    })
  }

}
